module.exports = __webpack_public_path__ + "static/media/ico_clock.e247ef83.svg";